module.exports = __webpack_public_path__ + "d1f4a967898affbca93b0660d622c06a.png";